import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import sw from "./locales/sw.json";

const savedLang = localStorage.getItem("lang") || "sw";

const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: "en",
  messages: { en, sw },
});

export default i18n;
